export const highLightColors = {
    SELECTED_BLOCK_HIGHLIGHT_COLOR: '#848484',
    SELECTED_ELEMENT_HIGHLIGHT_COLOR: '#4c3ba8bf',
    DEFAULT_BLOCK_WRAPPER_BACKGROUND_COLOR: '#84929b',
};

export const elementBorderColors = {
    IMAGE: '#EC7100',
    PARAGRAPH: '#009BF2',
    BUTTON: '#F6637A',
    SPACER: '#1CA2B2',
    SOCIAL: '#0D6EFD',
    SURVEY: '#4AA910',
    VIDEO: '#B569B4',
    TABLE: '#A65570',
};
